// @ts-nocheck
import React, { useState, useEffect, useContext } from 'react';
import Router, { useRouter } from 'next/router';
import ProductHistory from '@/components/product/history';
import Breadcrumbs from '@/components/breadcrumbs';
import { layout } from '@/theme';
import Fetch from '@/utils/Fetch';
import { useQuery } from '@tanstack/react-query';
import Time from '@/utils/time';
import Helper from '@/utils/helper';
import ToastContext from '@/utils/toast-context';
import * as Enums from '@/utils/enums';
import ConfirmAction from '@/components/modals/confirm-action';
import OptionService from '@/services/option/option-service';
import Storage from '@/utils/storage';
import BillingService from '@/services/billing-service';
import SubscriptionContext from '@/utils/subscription-context';
import AssetForm from "@/PageComponents/Inventory/AssetForm";
import {Box, Flex} from "@mantine/core";
import { createFileRoute } from '@tanstack/react-router'

function CreateProduct() {
  
  const subscriptionContext = useContext(SubscriptionContext);
  const router = useRouter();
  const { module, moduleID, customerID } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

  const getAccessStatus = async () => {
    const [subscriptionInfo, message] = await BillingService.getSubcriptionInfo(subscriptionContext);
    if (subscriptionInfo) {
      setHasCreditsAvailable(subscriptionInfo.SMSCreditsPurchased - (subscriptionInfo.SMSCreditsUsed ? subscriptionInfo.SMSCreditsUsed : 0) > 0);
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  };

  useEffect(() => {
    getAccessStatus();
    getStore();
  }, []);

  useEffect(() => {
    if (!router.isReady) return;
    if (module === String(Enums.Module.Customer)) {
      selectCustomer(moduleID);
    }
  }, [router.isReady]);

  const { data: customFieldsData } = useQuery(
    ['customFields', Enums.Module.Asset],
    () => Fetch.get({ url: `/Option?module=${Enums.Module.Asset}` })
  );

  useEffect(() => {
    if (customFieldsData) {
      getCustomFields(customFieldsData.Results);
    }
  }, [customFieldsData]);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace, "/");
    }
  }, [accessStatus]);

  const selectCustomer = async (id: any) => {
    if (id) {
      const customer = await Fetch.get({
        url: `/Customer/${id}`,
      });
      setSelectedCustomer(customer);
      setCustomers([customer]);
      setCustomerSearch(customer.CustomerName);
      setCustomerName(customer.CustomerName);
      setContacts(customer.Contacts);
      setSelectedContact(customer.Contacts ? customer.Contacts[0] : undefined);
      setCanChangeContact(true);
      setLocations(customer.Locations);
      setSelectedLocation(customer.Locations ? customer.Locations[0] : undefined);
      setCanChangeLocation(true);
    }
  };

  // STORES

  const [isMultiStore, setIsMultiStore] = useState(false);
  const [selectedStore, setSelectedStore] = useState<any>();

  const updateSelectedStore = (store: any) => {
    setSelectedStore(store);
    setFormIsDirty(true);
  }

  const getStore = async () => {
    //   url: `/Store/GetEmployeeStores?employeeID=${Storage.getCookie(Enums.Cookie.employeeID)}&searchPhrase=`,
    let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    let multistore = subscriptionInfo ? subscriptionInfo.MultiStore : false;

    setIsMultiStore(multistore);
  };

  /* Custom Fields */

  const [field1Label, setField1Label] = useState<any>();
  const [field2Label, setField2Label] = useState<any>();
  const [field3Label, setField3Label] = useState('');
  const [field4Label, setField4Label] = useState('');
  const [date1Label, setDate1Label] = useState('');
  const [date2Label, setDate2Label] = useState('');
  const [filter1Label, setFilter1Label] = useState('');
  const [filter2Label, setFilter2Label] = useState('');
  const [number1Label, setNumber1Label] = useState('');
  const [number2Label, setNumber2Label] = useState('');

  const [field1Required, setField1Required] = useState(false);
  const [field2Required, setField2Required] = useState(false);
  const [serialNumberRequired, setSerialNumberRequired] = useState(false);
  const [invoiceNumberRequired, setInvoiceNumberRequired] = useState(false);
  const [locationRequired, setLocationRequired] = useState(false);

  const getCustomFields = (customFieldsList: any) => {

    let { fieldLabel1, fieldLabel2, fieldLabel3, fieldLabel4, dateFieldLabel1, dateFieldLabel2,
      filterFieldLabel1, filterFieldLabel2, numberFieldLabel1, numberFieldLabel2,
      field1Required, field2Required, serialNumberRequired, invoiceNumberRequired, locationRequired 
    } = OptionService.getProductCustomFields(customFieldsList);

    setField1Label(fieldLabel1);
    setField2Label(fieldLabel2);
    setField3Label(fieldLabel3);
    setField4Label(fieldLabel4);
    setDate1Label(dateFieldLabel1);
    setDate2Label(dateFieldLabel2);
    setFilter1Label(filterFieldLabel1);
    setFilter2Label(filterFieldLabel2);
    setNumber1Label(numberFieldLabel1);
    setNumber2Label(numberFieldLabel2);
    setField1Required(field1Required);
    setField2Required(field2Required);
    setSerialNumberRequired(serialNumberRequired);
    setInvoiceNumberRequired(invoiceNumberRequired);
    setLocationRequired(locationRequired);
  };

  const toast = useContext(ToastContext);

  const [customers, setCustomers] = useState<any[]>([]);
  const [customerSearch, setCustomerSearch] = useState('');
  const [selectedCustomer, setSelectedCustomer] = useState<any>();
  const [selectedCustomerName, setCustomerName] = useState('');
  const [selectedCustomerProducts, setCustomerProducts] = useState<any[]>([]);
  const [customerProductsPage, setCustomerProductsPage] = useState(0);
  const [productSearching, setProductSearching] = useState(false);
  const [canLoadMoreProducts, setCanLoadMoreProducts] = useState(true);

  // CONTACTS

  const [contacts, setContacts] = useState<any[]>([]);
  const [contactSearch, setContactSearch] = useState('');
  const [selectedContact, setSelectedContact] = useState<any>();
  const [addingNewContact, setAddingNewContact] = useState(false);
  const [newContactFirstName, setNewContactFirstName] = useState('');
  const [newContactLastName, setNewContactLastName] = useState('');
  const [newContactEmail, setNewContactEmail] = useState('');
  const [newContactNumber, setNewContactNumber] = useState('');
  const [canChangeContact, setCanChangeContact] = useState(false);

  const [canSendEmail, setCanSendEmail] = useState(true);
  const [sendEmail, setSendEmail] = useState(true);
  const [canSendSms, setCanSendSMS] = useState(true);
  const [sendSMS, setSendSMS] = useState(true);
  const [hasCreditsAvailable, setHasCreditsAvailable] = useState<any>();

  // LOCATIONS

  const [locations, setLocations] = useState<any[]>([]);
  const [locationSearch, setLocationSearch] = useState('');
  const [selectedLocation, setSelectedLocation] = useState<any>();
  const [canChangeLocation, setCanChangeLocation] = useState(false);
  const [addingNewLocation, setAddingNewLocation] = useState(false);
  const [newLocationName, setNewLocationName] = useState('');
  const [newLocationType, setNewLocationType] = useState('');
  const [newSelectedLocationType, setNewSelectedLocationType] = useState<any>();
  const [newAddressLine1, setNewAddressLine1] = useState('');
  const [newAddressLine2, setNewAddressLine2] = useState('');
  const [newAddressLine3, setNewAddressLine3] = useState('');
  const [newAddressLine4, setNewAddressLine4] = useState('');
  const [newCountry, setNewCountry] = useState('');
  const [newSelectedCountry, setNewSelectedCountry] = useState<any>();

  // INVENTORY

  const [selectedInventory, setSelectedInventory] = useState<any>();

  const [formIsDirty, setFormIsDirty] = useState(false);
  const [confirmOptions, setConfirmOptions] = useState(Helper.initialiseConfirmOptions());

  Helper.preventRouteChange(formIsDirty, setFormIsDirty, setConfirmOptions, submitProduct, true);

  const handleInventoryChange = (inventory: any) => {
    setSelectedInventory(inventory);
    setFormIsDirty(true);
  };

  useEffect(() => {
    if (selectedInventory) {
      setPurchaseAmount(selectedInventory.ListPrice);
      setWarrantyPeriod(selectedInventory.WarrantyPeriod);
    }
  }, [selectedInventory]);

  const [purchaseDate, setPurchaseDate] = useState(Time.now());

  const handlePurchaseDateChange = (e: any) => {
    setPurchaseDate(e.value);
    setFormIsDirty(true);
  };

  const [purchaseAmount, setPurchaseAmount] = useState<any>();

  const handlePurchaseAmountChange = (e: any) => {
    setPurchaseAmount(e.value);
    setFormIsDirty(true);
  };

  const [invoiceNumber, setInvoiceNumber] = useState<any>();

  const handleInvoiceNumberChange = (e: any) => {
    setInvoiceNumber(e.value);
    setFormIsDirty(true);
  };

  const [serialNumber, setSerialNumber] = useState<any>();

  const handleSerialNumberChange = (e: any) => {
    setSerialNumber(e.value);
    setFormIsDirty(true);
  };

  const [customField1, setCustomField1] = useState<any>();

  const handleCustomField1Change = (e: any) => {
    setCustomField1(e.value);
    setFormIsDirty(true);
  };

  const [customField2, setCustomField2] = useState<any>();

  const handleCustomField2Change = (e: any) => {
    setCustomField2(e.value);
    setFormIsDirty(true);
  };

  const [customField3, setCustomField3] = useState<any>();

  const handleCustomField3Change = (e: any) => {
    setCustomField3(e.value);
    setFormIsDirty(true);
  };

  const [customField4, setCustomField4] = useState<any>();

  const handleCustomField4Change = (e: any) => {
    setCustomField4(e.value);
    setFormIsDirty(true);
  };

  const [customDate1, setCustomDate1] = useState<any>();

  const handleCustomDate1Change = (e: any) => {
    setCustomDate1(e.value);
    setFormIsDirty(true);
  };

  const [customDate2, setCustomDate2] = useState<any>();

  const handleCustomDate2Change = (e: any) => {
    setCustomDate2(e.value);
    setFormIsDirty(true);
  };

  const [customFilter1, setCustomFilter1] = useState(false);

  const handleCustomFilter1Change = (e: any) => {
    setCustomFilter1(!customFilter1);
  };

  const [customFilter2, setCustomFilter2] = useState(false);

  const handleCustomFilter2Change = (e: any) => {
    setCustomFilter2(!customFilter2);
  };

  const [customNumber1, setCustomNumber1] = useState<any>();  

  const handleCustomNumber1Change = (e: any) => {
    setCustomNumber1(e.value);
    setFormIsDirty(true);
  };

  const [customNumber2, setCustomNumber2] = useState<any>();  

  const handleCustomNumber2Change = (e: any) => {
    setCustomNumber2(e.value);
    setFormIsDirty(true);
  };

  const [warrantyPeriod, setWarrantyPeriod] = useState<any>();

  const handleWarrantyPeriodChange = (e: any) => {
    setWarrantyPeriod(e.value);
    setFormIsDirty(true);
  };

  const [lastServicedDate, setLastServicedDate] = useState(Time.now());

  const handleLastServicedDateChange = (e: any) => {
    setLastServicedDate(e.value);
    setFormIsDirty(true);
  };

  const [productNumber, setProductNumber] = useState('');

  const handleProductNumberChange = (e: any) => {
    setProductNumber(e.value);
    setFormIsDirty(true);
  };

  const [selectedProduct, setSelectedProduct] = useState<any>();

  const [submitting, setSubmitting] = useState(false);

  const selectProduct = (product: any) => {
    if (product == selectedProduct) {
      setSelectedProduct(undefined);
    } else {
      setSelectedProduct(product);
    }
  };

  async function getCustomerProducts(currentProducts: any, page: any) {
    setProductSearching(true);

    const products = await Fetch.get({
      url: `/Product/GetByCustomerID?customerID=${selectedCustomer.ID}&includeClosed=True&pageSize=5&pageIndex=${page}`
    });

    let newProducts = []
    newProducts.push(...currentProducts);
    newProducts.push(...products.Results);
    setCustomerProducts(newProducts);
    setProductSearching(false);

    if (products.ReturnedResults < 5) {
      setCanLoadMoreProducts(false);
    } else if (newProducts.length == products.TotalResults) {
      setCanLoadMoreProducts(false);
    }
  }

  function loadMoreProducts() {
    setCustomerProductsPage(customerProductsPage + 1);
    getCustomerProducts(selectedCustomerProducts, customerProductsPage + 1);
  }

  // SET CONTACTS WHEN SELECTED CUSTOMER OR PAGE IS CHANGED
  useEffect(() => {
    if (!selectedCustomer) return;
    const keys = Object.keys(customers);
    for (const key of keys) {
      if (customers[key].ID == selectedCustomer.ID) {
        setContacts(customers[key].Contacts);
        setCustomerName(customers[key].CustomerName);

        //SET SELECTED CONTACT TO NOTHING OR FIRST CONTACT IF ONLY ONE IS AVAILABLE
        if (customers[key].Contacts && customers[key].Contacts.length == 1) {
          setContactSearch(customers[key].Contacts[0].FirstName + " " + customers[key].Contacts[0].LastName);
          setSelectedContact(customers[key].Contacts[0]);
        } else {
          setContactSearch('');
          setSelectedContact(undefined);

          setSendEmail(false);
          setCanSendEmail(false);
          setSendSMS(false);
          setCanSendSMS(false);
        }

        setLocations(customers[key].Locations);

        if (customers[key].Locations && customers[key].Locations.length == 1) {
          setLocationSearch(customers[key].Locations[0].LocationDisplay);
          setSelectedLocation(customers[key].Locations[0]);
        } else {
          setLocationSearch('');
          setSelectedLocation(undefined);
        }
      }
    }
    setCustomerProductsPage(0);
    setCanLoadMoreProducts(true);
    if (selectedCustomer !== undefined) {
      setProductSearching(true);
      getCustomerProducts([], 0);
    }
  }, [selectedCustomer]);

  useEffect(() => {
    if (selectedContact) {
      setSendEmail(selectedContact.SendEmail);
      setCanSendEmail(selectedContact.SendEmail);
      setSendSMS(selectedContact.SendSMS);
      setCanSendSMS(selectedContact.SendSMS);
    }
  }, [selectedContact]);

  const [inputErrors, setInputErrors] = useState<any>({});

  const validate = () => {

    let validationItems = [];
    validationItems = [
      { key: 'Customer', value: selectedCustomer, required: true, type: Enums.ControlType.Select },
      { key: 'Inventory', value: selectedInventory, required: true, type: Enums.ControlType.Select },
      { key: 'PurchaseDate', value: purchaseDate, required: true, type: Enums.ControlType.Date },
      { key: 'PurchaseAmount', value: purchaseAmount, required: true, type: Enums.ControlType.Number },
      { key: 'WarrantyPeriod', value: warrantyPeriod, required: true, type: Enums.ControlType.Number },
    ];

    if (field1Required) {
      validationItems = [...validationItems,
      { key: 'CustomField1', value: customField1, required: true, type: Enums.ControlType.Text }];
    }

    if (field2Required) {
      validationItems = [...validationItems,
      { key: 'CustomField2', value: customField2, required: true, type: Enums.ControlType.Text }];
    }

    if (serialNumberRequired) {
      validationItems = [...validationItems,
      { key: 'SerialNumber', value: serialNumber, required: true, type: Enums.ControlType.Text }];
    }

    if (invoiceNumberRequired) {
      validationItems = [...validationItems,
      { key: 'InvoiceNumber', value: invoiceNumber, required: true, type: Enums.ControlType.Text }];
    }

    if (locationRequired) {
      validationItems = [...validationItems,
      { key: 'Location', value: selectedLocation, required: true, type: Enums.ControlType.Select }];
    }

    if (addingNewContact) {
      validationItems = [...validationItems,
      { key: 'FirstName', value: newContactFirstName, required: true, type: Enums.ControlType.Text },
      { key: 'LastName', value: newContactLastName, required: true, type: Enums.ControlType.Text },
      { key: 'EmailAddress', value: newContactEmail, type: Enums.ControlType.Email },
      { key: 'MobileNumber', value: newContactNumber, type: Enums.ControlType.ContactNumber },
      { key: 'EmailAddress', value: newContactEmail, type: Enums.ControlType.Email, group: 'email_number' },
      { key: 'MobileNumber', value: newContactNumber, type: Enums.ControlType.Number, group: 'email_number' },
      ];
    } else {
      validationItems = [...validationItems,
      { key: 'Contact', value: selectedContact, required: true, type: Enums.ControlType.Select },
      ];
    }

    if (addingNewLocation) {
      validationItems = [...validationItems,
      { key: 'newLocationName', value: newLocationName, required: true, type: Enums.ControlType.Text },
      { key: 'newAddressLine1', value: newAddressLine1, required: true, type: Enums.ControlType.Text },
      { key: 'newLocationType', value: newLocationType, required: true, type: Enums.ControlType.Text },
      { key: 'newCountry', value: newCountry, required: true, type: Enums.ControlType.Text },
      ];
    }

    // if (isMultiStore) {
    //   { key: 'Store', value: selectedStore, required: true, type: Enums.ControlType.Select }

    const { isValid, errors } = Helper.validateInputs(validationItems);
    setInputErrors(errors);
    return isValid;
  };

  const [assetFormState, setAssetFormState] = useState({
    inputErrors: {},
    submitState: 'none',
  })
  useEffect(() => {
    if(assetFormState.submitState === 'loading') {
      console.log('saving')
      setSubmitting(true);
    } else {
      setSubmitting(false);
    }
    /*if(assetFormState.submitState === 'success') {

    }*/
    if(assetFormState.submitState === 'error' && assetFormState.inputErrors) {
      /*toast.setToast({
        message: 'There are errors on the page',
        show: true,
        type: Enums.ToastType.error
      });*/
    }
  }, [assetFormState]);

  async function submitProduct(navToRoute: any) {
    setSubmitting(true);
    setAssetFormState((p: any) => ({
      ...p,
      submitState: 'onSubmit',
      ...(navToRoute && {navToRoute} || {})
    }))
    /*let isValid = validate();
    if (isValid) {
      let productContactID;
      let productLocationID;

      if (addingNewContact) {
        const newContactRes = await Fetch.post({
          url: '/Contact',
          params: {
            EmailAddress: newContactEmail,
            FirstName: newContactFirstName,
            LastName: newContactLastName,
            MobileNumber: newContactNumber,
            CustomerID: selectedCustomer.ID,
            IsActive: true,
          },
          toastCtx: toast
        });

        if (newContactRes.ID) {
          Helper.mixpanelTrack(constants.mixPanelEvents.createContact, {
            "contactID": newContactRes.ID
          });
          productContactID = newContactRes.ID;
        }
      } else {
        productContactID = selectedContact ? selectedContact.ID : '';
      }

      if (addingNewLocation) {
        const newLocationRes = await Fetch.post({
          url: '/Location',
          params: {
            Description: newLocationName,
            AddressLine1: newAddressLine1,
            AddressLine2: newAddressLine2,
            AddressLine3: newAddressLine3,
            AddressLine4: newAddressLine4,
            CustomerID: selectedCustomer.ID,
            LocationType: newSelectedLocationType.ID,
            CountryID: newSelectedCountry.ID,
            IsActive: true,
          },
          toastCtx: toast
        });

        if (newLocationRes.ID) {
          productLocationID = newLocationRes.ID;
        }
      } else {
        productLocationID = selectedLocation ? selectedLocation.ID : null;
      }

      let params = {
        CustomerID: selectedCustomer.ID,
        CustomerContactID: productContactID,
        LocationID: productLocationID,
        InventoryID: selectedInventory ? selectedInventory.ID : null,
        PurchaseDate: Time.toISOString(purchaseDate),
        PurchaseAmount: purchaseAmount,
        InvoiceNumber: invoiceNumber,
        SerialNumber: serialNumber,
        CustomField1: customField1,
        CustomField2: customField2,
        CustomField3: customField3,
        CustomField4: customField4,
        CustomDate1: customDate1 ? Time.toISOString(customDate1) : null,
        CustomDate2: customDate2 ? Time.toISOString(customDate2) : null,
        CustomFilter1: customFilter1,
        CustomFilter2: customFilter2,
        CustomNumber1: customNumber1,
        CustomNumber2: customNumber2,
        WarrantyPeriod: warrantyPeriod,
        LastServicedDate: Time.toISOString(lastServicedDate),
        SendEmail: sendEmail,
        SendSMS: sendSMS,
        StoreID: isMultiStore ? selectedStore ? selectedStore.ID : null : Helper.emptyGuid(),
        IsAllStore: true,
        ProductNumber: productNumber,
      };

      const productPost = await Fetch.post({
        url: `/Product`,
        params: params,
        toastCtx: toast
      });

      if (productPost.ID) {

        Helper.mixpanelTrack(constants.mixPanelEvents.createProduct, {
          "productID": productPost.ID
        });

        setFormIsDirty(false);
        await Helper.waitABit();

        toast.setToast({
          message: 'Asset created successfully',
          show: true,
          type: 'success'
        });

        if (isDuplicate) {
          setSerialNumber('');
          setCustomField1('');
          setCustomField2('');
          setProductNumber('');
          setSubmitting(false);
        } else {
          Helper.nextRouter(Router.push, '/asset/[id]', `/asset/${productPost.ID}`);
        }
      } else {
        setSubmitting(false);
      }
    } else {
      toast.setToast({
        message: 'There are errors on the page',
        show: true,
        type: Enums.ToastType.error
      });
      setSubmitting(false);
    }

    return isValid;*/
  }

  const cancel = () => {
    Helper.nextRouter(Router.push, '/customer/list?tab=assets');
  };

  return (
    <div className="manage-container">
      <div className="row">
        <div className="title">
          <Breadcrumbs currPage={{ text: 'Create Asset', link: '/asset/create', type: 'create' }} />
        </div>
      </div>

      <Flex
          direction={{base: 'column', xl: 'row'}}
          align={{base: 'start', xl: 'start'}}
          justify={{base: 'around', xl: 'center'}}
      >
        <Box maw={1000} w={'100%'} mt={'sm'}>
          <AssetForm
              assetCreated={(product: any) => {
                setFormIsDirty(false)
                Helper.nextRouter(Router.push, '/asset/[id]', `/asset/${product.ID}`);
              }}
              assetCreatedAndCopied={(product: any) => {
                setFormIsDirty(true)
              }}
              onCustomerChange={(c: any) => {
                setSelectedCustomer(c)
                setCustomerName(c?.CustomerName || '')
                if(!c) {
                  setCustomerProducts([])
                  setCustomerProductsPage(0)
                  setProductSearching(false)
                }
              }}
              onClose={cancel}
              formState={assetFormState}
              setFormState={setAssetFormState}
              assetPageMode
              onFormTouched={(touched: any) => setFormIsDirty(touched)}
              customerID={customerID}
          />
        </Box>
        <Flex w={'100%'} justify={'center'}  mr={{xl: 'sm'}}>
          <ProductHistory
              canLoadMoreProducts={canLoadMoreProducts}
              customer={selectedCustomerName}
              products={selectedCustomerProducts}
              productSearching={productSearching}
              loadMoreProducts={loadMoreProducts}
              selectedProduct={selectedProduct}
              setSelectedProduct={selectProduct}
          />
        </Flex>
      </Flex>

      {/*<div className="split">
        <div className="column">
            {isMultiStore ?
              <div>
                <StoreSelector
                  selectedStore={selectedStore}
                  setSelectedStore={updateSelectedStore}
                  error={inputErrors.Store}
                  cypress="data-cy-store"
                  getAllStores={true}
                />
              </div> : ''
            }

            <div style={{ marginTop: "0.5rem" }}>
              <CustomerContactLocationSelector isNew={true} selectedCustomer={selectedCustomer} setSelectedCustomer={setSelectedCustomer} canChangeCustomer={true}
                selectedContact={selectedContact} setSelectedContact={setSelectedContact} selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation}
                detailsView={false} module={Enums.Module.Asset} inputErrors={inputErrors} accessStatus={accessStatus} cypressCustomer={"data-cy-customer"}
                cypressContact={"data-cy-contact"} cypressLocation={"data-cy-location"} compactView={true}
              />
            </div>

          <Box maw={1000} mt={'sm'}>
            <CreateOrEditAssetForm
               assetCreated={(product) => {
                 setFormIsDirty(false)
                 console.log(product)
               }}
               onCustomerChange={setSelectedCustomer}
               onClose={cancel}
               formState={assetFormState}
               setFormState={setAssetFormState}
               assetPageMode
               onFormTouched={() => setFormIsDirty(true)}
            />
          </Box>

          <div>

            <InventorySelector
              accessStatus={accessStatus}
              error={inputErrors.Inventory}
              selectedInventory={selectedInventory}
              setSelectedInventory={handleInventoryChange}
            />

            <SCInput
              error={inputErrors.ProductNumber}
              hint="Leave blank to auto generate"
              label="Asset/Serial Number"
              value={productNumber}
              name="ProductNumber"
              onChange={handleProductNumberChange}
            />

            <div className="relative" >
              <SCDatePicker
                label="Purchase Date"
                required={true}
                changeHandler={handlePurchaseDateChange}
                value={purchaseDate}
                error={inputErrors.PurchaseDate}
              />

              <div className="indicator">
                <WarrantyIndicator purchaseDate={purchaseDate} warrantyPeriod={warrantyPeriod} />
              </div>

            </div>

            <SCNumericInput
              error={inputErrors.WarrantyPeriod}
              label="Warranty period"
              value={warrantyPeriod}
              name="WarrantyPeriod"
              onChange={handleWarrantyPeriodChange}
              required={true}
              min={0}
              format={Enums.NumericFormat.Integer}
            />

            <SCNumericInput
              error={inputErrors.PurchaseAmount}
              label="Purchase Amount"
              value={purchaseAmount}
              name="PurchaseAmount"
              onChange={handlePurchaseAmountChange}
              required={true}
              min={0}
              format={Enums.NumericFormat.Currency}
            />

            <SCInput
              error={inputErrors.InvoiceNumber}
              label="Invoice number"
              value={invoiceNumber}
              name="InvoiceNumber"
              onChange={handleInvoiceNumberChange}
              required={invoiceNumberRequired}
            />

            <SCInput
              error={inputErrors.SerialNumber}
              label="Other number"
              value={serialNumber}
              name="SerialNumber"
              onChange={handleSerialNumberChange}
              required={serialNumberRequired}
            />

            <SCDatePicker
              label="Last serviced date"
              changeHandler={handleLastServicedDateChange}
              value={lastServicedDate}
            />

            <SCInput
              label={field1Label}
              required={field1Required}
              onChange={handleCustomField1Change}
              value={customField1}
              error={inputErrors.CustomField1}
            />

            <SCInput
              label={field2Label}
              required={field2Required}
              onChange={handleCustomField2Change}
              value={customField2}
              error={inputErrors.CustomField2}
            />

            <SCInput
              label={field3Label}
              onChange={handleCustomField3Change}
              value={customField3}
              error={inputErrors.CustomField3}
            />

            <SCInput
              label={field4Label}
              onChange={handleCustomField4Change}
              value={customField4}
              error={inputErrors.CustomField4}
            />

            <SCDatePicker
              label={date1Label}
              changeHandler={handleCustomDate1Change}
              value={customDate1}
            />

            <SCDatePicker
              label={date2Label}
              changeHandler={handleCustomDate2Change}
              value={customDate2}
            />

            <SCCheckbox
              onChange={handleCustomFilter1Change}
              value={customFilter1}
              label={filter1Label}
            />

            <SCCheckbox
              onChange={handleCustomFilter2Change}
              checked={customFilter2}
              label={filter2Label}
            />

            <SCNumericInput
              onChange={handleCustomNumber1Change}
              label={number1Label}
              name="CustomNumber1"
              value={customNumber1}
              format={Enums.NumericFormat.Decimal}
            />

            <SCNumericInput
              onChange={handleCustomNumber2Change}
              label={number2Label}
              name="CustomNumber2"
              value={customNumber2}
              format={Enums.NumericFormat.Decimal}
            />

            <div className="create-buttons">
              <Button extraClasses="auto" text="Create and Duplicate" onClick={() => submitProduct(true)} disabled={submitting} />
              <Button extraClasses="auto" text="Create" onClick={() => submitProduct(false)} disabled={submitting} />
              <Button key={111} extraClasses="auto hollow" text="Cancel" onClick={() => cancel()} />
            </div>

          </div>
        </div>
        <ProductHistory
          canLoadMoreProducts={canLoadMoreProducts}
          customer={selectedCustomerName}
          products={selectedCustomerProducts}
          productSearching={productSearching}
          loadMoreProducts={loadMoreProducts}
          selectedProduct={selectedProduct}
          setSelectedProduct={selectProduct}
        />
      </div>*/}

      <ConfirmAction options={confirmOptions} setOptions={setConfirmOptions} />

      <style jsx>{`

      /*.relative {
        position: relative;
      }

      .indicator {
        position: absolute;
        top: 23px;
        right: -44px;
      }*/

        /*.column {
          display: flex;
          flex-direction: column;
          width: ${layout.inputWidth};
        }
        .column-margin {
          margin-left: 24px;
        }
        .button-container {
          flex-shrink: 0;
          width: 10rem;
        }*/
        .button-container :global(.button){
          margin-top: 0.5rem;
        }        
        /*.row {
          display: flex;
          justify-content: space-between;
        }
        .create-buttons {
          margin-top: 1rem;
          padding-bottom: 1rem;
          display: flex;
          flex-direction: row-reverse;
        }*/

        .create-buttons :global(.button){
          margin-left: 0.5rem;
          margin-top: 0;
          padding: 0 1rem;
          white-space: nowrap;
      }

      `}</style>
    </div>
  );
}

export default CreateProduct;

export const Route = createFileRoute('/_authenticated/asset/create')({ component: CreateProduct })
